import shuffle from 'knuth-shuffle-seeded';

/**
 * @param {any[]} items
 * @param {number} seed
 */
export default function seededShuffle(items, seed) {
  return shuffle([...items], seed);
}
